<template>
  <!-- 会员商城-活动列表 -->
  <div class="gift_list">
    <template v-if="createStep == 1">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="活动列表" name="first"></el-tab-pane>
        <el-tab-pane label="兑换记录" name="second"></el-tab-pane>
      </el-tabs>
      <template v-if="activeName == 'first'">
        <!-- <div class="topbox" v-if="inputShow">
          <div>活动列表</div>
        </div> -->
        <!-- 头部表单查询 -->
        <input-form
          :defaultSelectArr="true"
          ref="inputForm"
          v-if="inputShow"
          :inputData="inputData"
          @toParentVal="searchForm"
          :pageName="pageName"
          :btnPosition1="true"
          labelWidth="130px"
        ></input-form>
        <input-form v-if="inputShow1" :inputData="inputData1" @toParentVal="searchForm" :pageName="pageName" :btnPosition1="true"></input-form>
        <div v-if="statisType == 1" class="tabSwitch">
          <div class="tabSwitch-left">
            <div
              class="left-wz"
              @click="handleTab(index)"
              v-for="(item, index) in tabSwitchList"
              :key="index"
              :class="{ active: index == currIndex }"
            >
              {{ item }}
            </div>
          </div>
          <div>
            <el-button style="width: auto;" type="primary" @click="handleToDecoration">积分商城装修</el-button>
          </div>
        </div>
        <!-- <div v-if="statisType == 1">
          <el-button style="margin-bottom: 20px;width: auto;" @click="getphone()" v-preventReClick>批量导出兑换记录</el-button>
        </div> -->
        <!-- 表格内容 -->
        <el-table
          v-loading="talbeLoading"
          :data="tableData"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column label="礼品名称" width="250">
            <template slot-scope="scope">
              <div class="activityName">
                <el-popover v-if="formList.status != 5" placement="top-start" width="500" trigger="hover">
                  <p style="margin: 20px">
                    请用手机京东扫描下面二维码查看您店铺的活动详情
                  </p>
                  <!-- <img src="" alt="活动二维码" style="margin-left: 60px" /> -->
                  <!-- <div :id="'qrcode' + scope.row.id" :ref="'qrcode' + scope.row.id" style="margin-left: 80px"></div> -->
                  <qrcode-vue
                    class="qrcode"
                    :id="'qrcode' + scope.row.id"
                    :ref="'qrcode' + scope.row.id"
                    :size="qrcodeVue.size"
                    :value="scope.row.idUrl"
                    :logo="qrcodeVue.logo"
                    :bgColor="qrcodeVue.bgColor"
                    :fgColor="qrcodeVue.fgColor"
                    style="margin-left: 80px"
                  ></qrcode-vue>
                  <div>
                    <p style="margin: 20px">
                      链接地址：(手机京东店铺中活动详情链接地址)
                    </p>
                    <el-input v-model="scope.row.idUrl" style="margin: 0 20px; width: 220px"></el-input
                    ><el-button type="primary" v-clipboard:copy="scope.row.idUrl" v-clipboard:success="onCopy" v-clipboard:error="onError"
                      >复制</el-button
                    >
                    <el-button type="primary" @click="handleSrcImg(scope.row.id)">下载</el-button>
                  </div>
                  <img src="../../assets/images/integralCenter/list_code.svg" alt="活动二维码" class="code" slot="reference" />
                </el-popover>
                <span>{{ scope.row.activityName }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="礼品类型" prop="activityType">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.activityType == 9 ? "兑换实物" : "兑换优惠券" }}</span> -->
              <span>{{ scope.row.activityType | activityString }}</span>
            </template>
          </el-table-column>

          <el-table-column v-if="formList.status != 5" label="面值" prop="price" key="price">
            <!-- <template slot-scope="scope">
                  </template> -->
          </el-table-column>

          <el-table-column v-if="formList.status != 5" label="所需积分" width="180">
            <template slot="header">
              <span>所需积分</span> &nbsp;
              <span class="open" v-show="!tableOpenAll" @click="tableOpenAll = true">展开全部</span>
              <span class="stop" v-show="tableOpenAll" @click="tableOpenAll = false">收起全部</span>
            </template>
            <template slot-scope="scope">
              <!-- <div v-show="!tableOpenAll">
                <span>
                  {{ scope.row.memberLevelPointsListVOS[0].levelName }}:
                  {{ scope.row.memberLevelPointsListVOS[0].point }}
                </span>
              </div>

              <div class="hoveTitleShowMore" v-show="tableOpenAll">
                <template v-for="item in scope.row.memberLevelPointsListVOS">
                  <p v-if="item.allow" :key="item.level">{{ item.levelName }}：{{ item.point }}</p>
                </template>
              </div> -->
              <div v-if="!tableOpenAll">
              <span>
                {{
                  scope.row.memberLevelPointsListVOS.find(
                    (item) => item.allow === true
                  ).levelName
                }}:
                {{
                  scope.row.memberLevelPointsListVOS.find(
                    (item) => item.allow === true
                  ).point
                }}
              </span>
            </div>

            <div class="hoveTitleShowMore" v-else-if="tableOpenAll">
              <template v-for="item in scope.row.memberLevelPointsListVOS">
                <p v-if="item.allow" :key="item.level">
                  {{ item.levelName }}：{{ item.point }}
                </p>
              </template>
            </div>
            </template>
          </el-table-column>

          <el-table-column v-if="formList.status != 5" label="总数/已兑">
            <template slot-scope="scope">
              <span>{{ scope.row.num }}</span
              >/
              <span>{{ scope.row.sendNum }}</span>
            </template>
          </el-table-column>

          <el-table-column label="上下架时间" :width="formList.status != 5?200:''">
            <template slot-scope="scope">
              <div class="activityTime" v-if="formList.status != 5">
                <span>上架: {{ scope.row.startTime }}</span>
                <span>下架: {{ scope.row.endTime }}</span>
                <span style="color: #7b61ff;">{{ scope.row.days }}</span>
              </div>
              <div class="activityTime2" v-else>
                <span>{{ scope.row.startTime?scope.row.startTime:"-" }}</span>
                <span class="activityTime2_line">至</span>
                <span>{{ scope.row.endTime?scope.row.endTime:'-' }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="isDisplay" width="200" v-if="currIndex!=4">
              <template #header>
                <span>是否在商城显示</span>
                <el-tooltip class="item" effect="light" content="开启后，会在积分商场列表显示" placement="top">
                  <i style="color: #ccc" class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.isDisplay"
                  active-color="#49C568"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handleChangeDisplayOrSort($event, scope.row,'isDisplay')"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column prop="sort" width="200" v-if="currIndex!=4">
              <template #header>
                <span>展示优先级</span>
                <el-tooltip class="item" effect="light" content="数字越小优先级越高，展示在越前面，优先级相同时，按最后修改时间最近优先展示；" placement="top">
                  <i style="color: #ccc" class="el-icon-question"></i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.sort" @change="handleChangeDisplayOrSort($event, scope.row,'sort')" :min="1"></el-input-number>
              </template>
            </el-table-column>

          <el-table-column label="最后修改时间" prop="updateTime" width="200"> </el-table-column>
          <el-table-column v-if="formList.status != 5" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1"> <i class="y1"></i>待上架 </span>
              <span v-if="scope.row.status == 2"> <i class="y2"></i>已上架 </span>
              <span v-if="scope.row.status == 3"> <i class="y3"></i>已下架 </span>
            </template>
          </el-table-column>
          <el-table-column label="参与人数" width="120" prop="joinNum" v-if="tabSwitchList[currIndex] != '草稿箱'">
            <template slot-scope="scope">
              {{scope.row.joinNum || 0}}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="360">
            <template slot-scope="scope">
              <div v-if="formList.status != 5" class="editList">
                <!-- 积分兑换实物添加编辑 -->
                <span class="edit" 
                    v-if="scope.row.status == 1&&scope.row.activityType == 9"
                    @click="modify(scope.row,'edit')"
                    >
                编辑
              </span>
                <span class="edit"   v-else-if="scope.row.status == 1&&scope.row.activityType != 9"  v-zoom="{ from: pageName + '礼品列表', name: '编辑' }" @click="changeList(scope.row)"
                  >编辑</span
                >
                <span class="edit"   v-if="scope.row.status == 2" @click="scope.row.activityType == 9 ? modify(scope.row,'edit') : changeList(scope.row)"
                  >修改</span
                >
                <span class="edit" v-if="scope.row.status == 2 || scope.row.status == 3" @click="seeList(scope.row)">查看</span>
                <span class="edit" @click="seeList(scope.row,scope.row.activityType,true)">复制</span>
                <span class="count" v-if="scope.row.status == 1" @click="updateList(scope.row)" v-zoom="{ from: pageName + '礼品列表', name: '上架' }"
                  >上架</span
                >
                <span class="count" v-if="scope.row.status == 2" @click="updateList(scope.row)" v-zoom="{ from: pageName + '礼品列表', name: '下架' }"
                  >下架</span
                >
               <span
                  v-if="scope.row.status == 2&&scope.row.activityType == 9"
                  class="delete"
                  v-zoom="{ from: pageName + '礼品列表', name: '奖品库存' }"
                  @click="addInventory(scope.row)"
                  >奖品库存</span
                 >
                <span class="count" @click="statisData(scope.row)">数据统计</span>
                <span class="delete" v-zoom="{ from: pageName + '礼品列表', name: '删除' }" @click="deleteById(scope.row)">删除</span>
                <span
                  class="edit"
                  @click="handleWhiteList(scope.row)"
                  >白名单</span
                 >
              </div>
              <div v-else>
                <el-button type="text" class="draft-btn" @click="editDraft(scope.row)">编辑</el-button>
                <el-button type="text" class="draft-btn" @click="deleteById(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          v-if="pageshow"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="10"
          background
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="totalNum"
        >
        </el-pagination>
      </template>
      <template v-if="activeName == 'second'">
        <!-- 头部表单查询 -->
        <input-form
          :defaultSelectArr="true"
          ref="inputForm2"
          :inputData="inputData2"
          @toParentVal="searchForm2"
          :pageName="pageName"
          :btnPosition1="true"
        ></input-form>
        <div v-if="statisType == 1">
          <el-button
            style="float: left; margin-bottom: 20px; width: 150px"
            @click="addCrowd(4)"
            >按查询结果生成人群</el-button
          >
          <el-button
            style="float: left; margin-bottom: 20px; width: 120px"
            @click="batchMarkForShipment"
            v-preventReClick
            >批量标记发货</el-button
          >
          <el-button style="margin-bottom: 20px;width: auto;float: right;" @click="getphone()" v-preventReClick>导出</el-button>
        </div>
        <!-- 表格内容 -->
        <el-table
          :key="activeName"
          v-loading="talbeLoading"
          :data="tableData2"
          style="width: 100%; margintop: 20px"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>

          <el-table-column label="用户昵称" prop="memberNick">
             <template slot-scope="scope">
              {{scope.row.memberNick}}
              </template>
          </el-table-column>
          <el-table-column label="中奖ID" prop="id"></el-table-column>
          <el-table-column label="礼品名称" prop="prizeName">
            <template slot-scope="scope">
              {{scope.row.prizeName}}
              </template>
          </el-table-column>
          <el-table-column label="礼品类型" prop="prizeType">
            <template slot-scope="scope">
              <!-- <span>{{ scope.row.activityType | activityString }}</span> -->
              <span v-if="scope.row.prizeType == 1">兑换优惠券</span>
              <span v-if="scope.row.prizeType == 2">京豆</span>
              <span v-if="scope.row.prizeType == 3">兑换实物</span>
              <span v-if="scope.row.prizeType == 4">店铺积分</span>
              <span v-if="scope.row.prizeType == 5">E卡</span>
              <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
              <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
              <span v-if="scope.row.prizeType == 8">红包</span>
              <span v-if="scope.row.prizeType == 9">谢谢参与</span>
              <span v-if="scope.row.prizeType == 10">
                {{ scope.row.activateType==2 ? '百度网盘' :'礼品卡'}}
              </span>
              <span v-if="scope.row.prizeType == 11">积分加钱购</span>
            </template>
          </el-table-column>
          <el-table-column label="消耗积分"  prop="point"></el-table-column>
          <el-table-column label="兑换时间" width="200">
            <template slot-scope="scope">
              <div class="activityTime">
                <span>{{ scope.row.exchangeTime }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="兑换状态">
            <template slot-scope="scope">
              <span v-if="scope.row.exchangeStatus == 1" 
                >兑换成功</span
              >
              <span v-if="scope.row.exchangeStatus == 2" >
                兑换失败
                <!-- <img
                  src="@/assets/images/ask.png"
                  alt=""
                  class="questionMark"
                /> -->
                <!-- <el-popover
                  placement="top-start"
                  width="200"
                  trigger="hover"
                  :content="scope.row.exchangeStatus"
                >
                  <img
                    src="@/assets/images/ask.png"
                    alt=""
                    class="questionMark"
                    slot="reference"
                  />
                </el-popover> -->
              </span>
              <span v-if="scope.row.exchangeStatus == 3" 
                >领取成功</span
              >
              <span v-if="scope.row.exchangeStatus == 4" 
                >已撤回</span
              >
            </template>
          </el-table-column>
          <el-table-column label="发货状态" prop="deliveryStatus">
            <template slot-scope="scope">
              <span v-if="scope.row.deliveryStatus == 1" 
                >待发货</span
              >
              <span v-if="scope.row.deliveryStatus == 2" >
                已发货
              </span>
              <span v-if="scope.row.deliveryStatus == 3" 
                >无需发货（非实物）</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="receiverName" label="收货人" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5 || scope.row.prizeType == 8"> -</div>
              <div class="open" v-else>
                {{ scope.row.receiverName }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverName &&
                    scope.row.receiverName.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt1('receiverName', scope.row, scope.$index)
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 收件人手机号 -->
          <el-table-column
            prop="receiverMobile"
            label="收件人手机号"
            width="120"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5 || scope.row.prizeType == 8"> -</div>
              <div class="open" v-else>
                {{ scope.row.receiverMobile }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverMobile &&
                    scope.row.receiverMobile.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt1('receiverMobile', scope.row, scope.$index)
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverRegion" label="收货地区" width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5  || scope.row.prizeType == 8"> -</div>
              <div class="open" v-else>
                {{ scope.row.receiverRegion ?  scope.row.receiverRegion: '-' }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverRegion &&
                    scope.row.receiverRegion.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt1('receiverRegion', scope.row, scope.$index)
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="receiverAddress" label="详细地址" width="250">
            <template slot-scope="scope">
              <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5  || scope.row.prizeType == 8"> -</div>
              <div class="open" v-else>
                {{ scope.row.receiverAddress }}
                <div
                  class="openHover"
                  v-if="
                    scope.row.receiverAddress &&
                    scope.row.receiverAddress.indexOf('*') != -1
                  "
                  @click="
                    handleDecrypt1('receiverAddress', scope.row, scope.$index)
                  "
                >
                  展开
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="billCode" label="快递单号">
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <div v-if="scope.row.prizeType == 1|| scope.row.prizeType == 2 || scope.row.prizeType == 5 || scope.row.prizeType == 8 "></div>
              <div v-else class="btn-wrap">
                <span
                  v-if="scope.row.deliveryStatus == 1 && scope.row.exchangeStatus != 4"
                  class="delivery"
                  @click="changeShip(scope.row)"
                >
                  标记发货
                </span>
                <span
                  v-else-if="scope.row.deliveryStatus == 1 && scope.row.exchangeStatus == 4"
                  style="color: #666666;"
                  class="delivery"
                >
                  标记发货
                </span>

                <span class="delivery" v-else-if="scope.row.deliveryStatus == 2 && scope.row.exchangeStatus != 4" @click="cancelShip(scope.row)"> 取消发货 </span>
                <span class="delivery" v-else-if="scope.row.deliveryStatus == 2 && scope.row.exchangeStatus == 4" style="color: #666666;"> 取消发货 </span>
                <div class="delivery" @click="shipment(scope.row)" v-if="scope.row.exchangeStatus != 4"> 录入快递单号 </div>
                <div class="delivery" style="color: #666666;" v-else> 录入快递单号 </div>
                <!-- B待发货和已发货都可撤回 -->
                <span @click="revocationIntegralGoods(scope.row)" v-if="(scope.row.deliveryStatus == 1 || scope.row.deliveryStatus == 2) && scope.row.exchangeStatus != 4" class="delivery"> 撤回 </span>
                <span style="color: #666666;" class="delivery" v-else> 撤回 </span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          v-if="pageshow"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="10"
          background
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="totalNum"
        >
        </el-pagination>
      </template>
    </template>
    <!-- 编辑弹窗 -->
    <el-dialog title="详情" :visible.sync="dialogFormVis" width="60%" >
      <div style="overflow-y: auto;height: 500px;padding-right: 10px;">
        <el-form :model="amendForm" label-width="130px">
          <el-form-item label="礼品名称:" v-if="theSta == 1">
            <el-input disabled v-model="amendForm.activityName" maxlength="15" show-word-limit style="width: 320px"></el-input>
          </el-form-item>
          <!-- 活动对象 -->
          <information
            ref="information" 
            :isStart="true"
            v-model="amendForm.ruleDTO" 
          />
          <template v-if="amendForm.activityType == 9 || amendForm.activityType == 30">
            <el-form-item label="参与条件：">
              <div>
                <el-radio-group v-model="amendForm.ruleDTO.exchangeConditions" :disabled="isDisabled">
                  <el-radio :label="0">满足参与身份即可参与</el-radio>
                  <el-radio :label="1">先下单后参与</el-radio>
                </el-radio-group>
              </div>
              <div
                v-if="amendForm.ruleDTO.exchangeConditions == 1"
                style="padding: 20px 0; background-color: #f2f2f2;margin-top: 16px;"
              >
                <el-form-item label="下单时间：" required>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="amendForm.ruleDTO.orderStartTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 150px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      :disabled="isDisabled"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="amendForm.ruleDTO.orderEndTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 160px; font-size: 12px"
                      class="time2"
                      :clearable="false"
                      :disabled="isDisabled"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="金额统计类型：" required>
                  <el-radio-group v-model="amendForm.ruleDTO.orderPaymentType" :disabled="isDisabled">
                    <el-radio :label="0">实付金额</el-radio>
                    <el-radio :label="1">订单金额</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="商品要求：" required>
                  <div class="flexc-cen-x">
                    <el-radio-group 
                      v-model="amendForm.ruleDTO.filterType" 
                      :disabled="isDisabled"
                    >
                      <el-radio :label="0">全部商品</el-radio>
                      <el-radio :label="1">指定商品</el-radio>
                      <el-radio :label="2">排除商品</el-radio>
                    </el-radio-group>
                    <el-button 
                      style="margin-left: 12px;"
                      :disabled="amendForm.ruleDTO.filterType == 0 || isDisabled"
                      @click="selectGoodsState = true"
                    >
                      已选择{{ isDisabled ? amendForm.ruleDTO.skuIdList && amendForm.ruleDTO.skuIdList.length : itemListForFilter.length }}个
                    </el-button>
                  </div>
                  <div style="margin-top: 16px;" v-if="amendForm.ruleDTO.filterType != 0">
                    <el-select
                      v-model="amendForm.ruleDTO.filterSkuType"
                      :disabled="isDisabled"
                      placeholder="请选择"
                      style="width: 320px"
                    >
                      <template v-if="amendForm.ruleDTO.filterType == 1">
                        <el-option label="只要订单包含指定商品就整单计算" :value="0" />
                        <el-option label="仅统计订单内指定商品的金额和件数" :value="1" />
                      </template>
                      <template v-if="amendForm.ruleDTO.filterType == 2">
                        <el-option label="只要订单包含指定商品就整单排除" :value="0" />
                        <el-option label="仅统计订单内非排除商品的金额和件数" :value="1" />
                      </template>
                    </el-select>
                  </div>
                </el-form-item>
                <el-form-item label="商品件数：">
                  <el-input
                    v-model="amendForm.ruleDTO.itemLimitCount"
                    :disabled="isDisabled"
                    style="width: 120px"
                    placeholder="请输入"
                  />
                  <span class="ml6">件及以上</span>
                </el-form-item>
                <el-form-item label="订单金额：" required>
                  <el-input
                    v-model="amendForm.ruleDTO.orderPaymentLimit"
                    :disabled="isDisabled"
                    style="width: 120px"
                    placeholder="请输入"
                  />
                  <span class="ml6">元及以上</span>
                </el-form-item>
                <el-form-item label="订单状态：" required>
                  <el-radio-group v-model="amendForm.ruleDTO.orderType" :disabled="isDisabled">
                    <el-radio :label="0">已付款</el-radio>
                    <el-radio :label="1">已完成</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="统计规则：" required>
                  <el-radio-group v-model="amendForm.ruleDTO.orderCountType" :disabled="isDisabled">
                    <el-radio :label="0">按单笔订单统计</el-radio>
                    <el-radio :label="1">按累计订单统计</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="下单跳转链接：">
                  <div>
                    <el-radio-group v-model="amendForm.ruleDTO.goShopSetting" :disabled="isDisabled">
                      <el-radio :label="0">进入店铺首页</el-radio>
                      <el-radio :label="1">跳转指定小程序</el-radio>
                      <el-radio :label="2">进入指定链接</el-radio>
                    </el-radio-group>
                  </div>
                  <div style="margin-top: 16px;">
                    <el-form-item
                      v-if="amendForm.ruleDTO.goShopSetting == 1"
                      label="小程序appId："
                      required
                    >
                      <el-input
                        v-model="amendForm.ruleDTO.goShopAppId"
                        :disabled="isDisabled"
                        placeholder="请输入小程序appId"
                        style="width: 320px"
                      />
                    </el-form-item>
                    <el-form-item
                      v-if="amendForm.ruleDTO.goShopSetting != 0"
                      :label="
                        amendForm.ruleDTO.goShopSetting == 1
                          ? '页面路径path:'
                          : '指定链接：'
                      "
                      :required="amendForm.ruleDTO.goShopSetting == 2"
                    >
                      <div>
                        <el-input
                          v-model="amendForm.ruleDTO.goShopUrl"
                          :disabled="isDisabled"
                          placeholder="请输入"
                          style="width: 320px"
                        />
                      </div>
                      <div style="color: red; font-size: 12px">
                        {{
                          amendForm.ruleDTO.goShopSetting == 1
                            ? "注意：path若不写，则默认进入小程序主页"
                            : "注意：仅可填写京东域内的H5页面地址，不可设置外链。参考链接：https://m.jd.com/。"
                        }}
                      </div>
                    </el-form-item>
                  </div>
                </el-form-item>
              </div>
            </el-form-item>
          </template>
          <el-form-item label="礼品名称:" v-if="theSta == 0">
            <el-input v-model="amendForm.activityName" maxlength="15" show-word-limit style="width: 320px"></el-input>
          </el-form-item>
          <el-form-item label="添加优惠券:" v-if="couponTxt.couponId">
            <div>
              <div class="couponContent">
                <div class="txtNum">
                  ￥
                  <span style="font-size: 36px; color: #7B61FF">{{ couponTxt.discount }}</span>
                </div>
                <div class="txtSize">
                  满 {{ couponTxt.quota }} 元可使用 <br />
                  {{ couponTxt.bindType == 1 ? "店铺券" : "商品券" }}
                </div>
                <p class="time">有效期:{{ couponTxt.beginTime }}~{{ couponTxt.endTime }}</p>
              </div>
              <p class="pContent">优惠券名称：{{ couponTxt.name }}</p>
              <p class="pContent">发行量：{{ couponTxt.num }}</p>
              <br />
              <p class="pContent">领券开始时间：{{ couponTxt.takeBeginTime }}</p>
              <p class="pContent">领券结束时间：{{ couponTxt.takeEndTime }}</p>
              <br />
              <p class="pContent">限领规则：{{ couponTxt.takeRule == 5 ? "活动期间限领一张" : "每天限领一张" }}</p>
            </div>
          </el-form-item>
          <el-form-item label="礼品价值:" v-if="amendForm.activityType == 9|| activityTypeListAll.includes(amendForm.activityType)">
            <el-input disabled v-model="amendForm.price" show-word-limit style="width: 136px"></el-input>&nbsp;元
          </el-form-item>
          <el-form-item label="礼品图片:" v-if="amendForm.activityType != 10">
            <img :src="amendForm.logo" style="width: 146px; height: 146px" />
            <p style="color: #7B61FF; font-size: 12px">
              建议尺寸：750*420像素，图片大小不能超过1.5MB，类型：JPG、PNG
            </p>
          </el-form-item>
          <el-form-item label="活动类型:">
            <el-radio-group v-model="amendForm.activityType" disabled>
              <el-radio :label="9" style="margin-right: 15px;margin-bottom: 15px;">积分兑换实物</el-radio>
              <el-radio :label="10" style="margin-right: 15px;margin-bottom: 15px;">积分兑换优惠券</el-radio>
              <el-radio :label="29" style="margin-right: 15px;margin-bottom: 15px;">积分兑换京豆</el-radio>
              <el-radio :label="30" style="margin-right: 15px;margin-bottom: 15px;">积分兑换E卡</el-radio>
              <el-radio :label="38" style="margin-right: 15px;margin-bottom: 15px;">积分红包</el-radio>
              <el-radio :label="58" style="margin-right: 15px;margin-bottom: 15px;">积分兑换爱奇艺会员</el-radio>
              <el-radio :label="59" style="margin-right: 15px;margin-bottom: 15px;">积分兑换京东PLUS会员</el-radio>
              <el-radio :label="60" style="margin-right: 15px;margin-bottom: 15px;">积分兑换礼品卡</el-radio>
              <el-radio :label="61" style="margin-right: 15px;margin-bottom: 15px;">积分兑换百度网盘</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="礼品价值:" v-if="amendForm.activityType == 9 || amendForm.activityType == 10">
            <el-input v-model="amendForm.price" style="width: 180px" disabled></el-input>
            元
          </el-form-item>
          <el-form-item label="上下架时间:">
            <div class="my_select_time">
              <el-date-picker
                disabled
                v-model="amendForm.startTime"
                type="datetime"
                size="small"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 180px; font-size: 12px"
              >
              </el-date-picker>
              <span> 至 </span>
              <el-date-picker
                disabled
                v-model="amendForm.endTime"
                type="datetime"
                size="small"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 180px; font-size: 12px"
              >
              </el-date-picker>
            </div>
            <span class="lastTime">
              活动持续
              <span style="color: #7B61FF">{{ timeDay }}</span> 天
            </span>
          </el-form-item>
          <el-form-item label="最后修改时间:">
            <div class="my_select_time">
              <el-date-picker
                disabled
                v-model="amendForm.updateTime"
                type="datetime"
                size="small"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 180px; font-size: 12px"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="京豆套餐:" v-if="amendForm.activityType == 29 && amendForm.exchangeType == 1">
            <el-table
              :data="amendForm.exchangeSet"
              border
              style="width: 542px; border: 1px solid #f0f0f0"
              :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column prop="singleNum" label="单个套餐京豆数量（个）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.singleNum" disabled></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="total" label="套餐数量（个）">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.total" disabled></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="次数限制:" v-if="amendForm.activityType == 29">
            <el-radio-group v-model="amendForm.ruleType" disabled>
              <el-radio :label="1">每人每日兑换次数</el-radio>
              <el-radio :label="2">每人活动内兑换次数</el-radio>
            </el-radio-group>
            <div>
              <el-input v-model="amendForm.limitVal" disabled placeholder="请输入" style="width: 120px"></el-input>
              次（最多20次）
            </div>
          </el-form-item>
          <el-form-item label="每人限兑次数:" v-if="(amendForm.activityType == 9 ) || amendForm.activityType == 10">
            <div class="limitBox">
              <el-input disabled v-model="amendForm.exchangeTimes" style="width: 180px"></el-input>
              次
              <p class="desc">
                <img
                  src="@/assets/images/new_icon_reminder1.png"
                  style="
                    display: inline-block;
                    float: left;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 9px 4px 0 3px;
                  "
                />
                不填则默认不限
              </p>
            </div>
          </el-form-item>
          <el-form-item :label="amendForm.activityType == 30 ? '兑换次数限制:' : '数量限制:'" v-else-if="amendForm.activityType != 9 && amendForm.activityType != 38 ">
            <span> 活动期间每人每天最多可兑换</span>
            <el-input v-model="amendForm.exchangeDayNum" disabled placeholder="不限制" style="width: 136px;margin:0 5px;"></el-input>
            <span>次，累计每人最多可兑换</span>
            <el-input v-model="amendForm.exchangeNum" disabled placeholder="不限制" style="width: 136px;margin:0 5px;"></el-input>
            <span>次</span>
          </el-form-item>
          <el-form-item label="发放数量:" v-if="[58,59].includes(amendForm.activityType)">
            <span>活动期间每日最多可兑换</span>
            <el-input v-model="amendForm.exchangeNumPerDay" disabled placeholder="不限制" style="width: 136px;margin:0 5px;"></el-input>
            <span>张，累计最多可兑换</span>
            <el-input v-model="amendForm.quantityTotal" disabled placeholder="不限制" style="width: 136px;margin:0 5px;"></el-input>张
          </el-form-item>

          <el-form-item :label="labelText" required v-if="activityTypeListAll.includes(amendForm.activityType)">
            <el-select
              v-model="amendForm.itemId"
              style="width: 320px; margin-right: 10px"
              @change="handlePrizeChange($event,1)"
              disabled
              v-if="amendForm.activityType == 58 || amendForm.activityType == 59"
            >
              <el-option
                v-for="item in prizeMemberList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="amendForm.assetsId"
              style="width: 320px; margin-right: 10px"
              @change="handlePrizeChange($event,2)"
              disabled
              v-else-if="amendForm.activityType == 60 || amendForm.activityType == 61"
            >
              <el-option
                v-for="item in giftCardList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

        <el-form-item label="发行总量:" v-if="[60,61].includes(amendForm.activityType)" required>
          <el-input v-model="amendForm.quantityTotal" disabled placeholder="请输入" style="width: 136px;margin:0 5px;"></el-input>次
          <div v-if="amendForm.activityType == 60 || amendForm.activityType == 61">
            剩余 <span class="tip-color">{{ quantityBalance }}</span> 张
          </div>
        </el-form-item>
          <el-form-item label="选择E卡:" v-if="amendForm.activityType == 30">
            <el-select v-model="amendForm.itemId" placeholder="请选择" disabled>
              <el-option label="1元" value="2"></el-option>
              <el-option label="5元" value="3"></el-option>
              <el-option label="20元" value="4"></el-option>
              <el-option label="50元" value="5"></el-option>
              <el-option label="100元" value="6"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="兑换次数限制:"  v-if="amendForm.activityType == 38">
                <div>
                  <span> 每人每日兑换次数：</span>
                  <el-input v-model="amendForm.exchangeDayTimes" placeholder="请输入" :disabled="true" style="width: 136px;margin:0 5px;"></el-input>
                  <el-tooltip class="item" effect="light" content="每人每日兑换次数需≤20次，且不可超过每人活动内兑换次数设置数" placement="bottom">
                    <el-button type="text" style="width: 35px;">
                      <i class="el-icon-question" style="color:#ccc"></i>
                    </el-button>
                  </el-tooltip>
                </div>
                <div style="margin-top: 20px;">
                  <span> 每人活动内兑换次数：</span>
                  <el-input v-model="amendForm.exchangeTimes" placeholder="请输入" :disabled="true" style="width: 136px;margin:0 5px;"></el-input>
                  <el-tooltip class="item" effect="light" content="每人活动内兑换次数需≤20次" placement="bottom">
                    <el-button type="text" style="width: 35px;">
                      <i class="el-icon-question" style="color:#ccc"></i>
                    </el-button>
                  </el-tooltip>
                </div>
          </el-form-item>

          <el-form-item label="红包份数限制:" v-if="amendForm.activityType == 38">
            <el-tooltip class="item" effect="light" content="每人每天兑换红包的份数设置，每天累计领取红包金额不超过10000元，单次可领取红包面额最大为4999元。" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question" style="color:#ccc"></i>
                </el-button>
            </el-tooltip>
            <div>
              <span> 每人每日兑换份数：</span>
              <el-input v-model="amendForm.exchangeDayNum" placeholder="请输入" disabled style="width: 136px;margin:0 5px;"></el-input>
            </div>
            <div style="margin-top: 20px;">
              <span> 每人活动内兑换份数：</span>
              <el-input v-model="amendForm.exchangeNum" placeholder="请输入" disabled style="width: 136px;margin:0 5px;"></el-input>
            </div>
          </el-form-item>

          <el-form-item label="红包有效期:"  v-if="amendForm.activityType == 38">
            <el-radio-group v-model="amendForm.redPacketExpiration" disabled>
              <el-radio :label="2">相对时间</el-radio>
              <el-radio :label="1">绝对时间</el-radio>
            </el-radio-group>
            <div v-if="amendForm.redPacketExpiration == 2">
              领取后 <el-input v-model="amendForm.effectiveDays" disabled style="width: 136px"></el-input
            > 天内有效
            </div>
            <div v-if="amendForm.redPacketExpiration == 1">
              <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="amendForm.startTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 135px; font-size: 12px"
                class="time1"
                :clearable="false"
                :disabled="true"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="amendForm.effectiveEndTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time2"
                :clearable="false"
                :disabled="true"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime2()"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            </div>
          </el-form-item>

          <!-- redPrice -->
          <el-form-item label="单份红包金额:" v-if="amendForm.activityType == 38">
            <el-input v-model="amendForm.price"   
            disabled
            style="width: 136px"></el-input
            >元
            <el-tooltip class="item" effect="light" content="单份红包设置：最大份额4999元，最小面额：0.1元" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question" style="color:#ccc"></i>
                </el-button>
            </el-tooltip>
          </el-form-item>


          <el-form-item v-if="![58,59,60,61].includes(amendForm.activityType)" :label="amendForm.activityType == 29 || amendForm.activityType == 30 || amendForm.activityType == 38 ? '发放总量:' : '总份数:'">
            <el-input disabled v-model="amendForm.quantityTotal" show-word-limit style="width: 136px"></el-input>&nbsp;
            {{ amendForm.activityType == 29 ? "个" : amendForm.activityType == 30 ? "张" : "份" }}
          </el-form-item>


          <el-form-item label="兑换所需积分:">
            <div class="isLevelSet">
              <template>
                <ul class="levelList" v-for="(item, index) in memberLevelList" :key="index">
                  <li class="item" v-if="item.allow == true" style="width: 240px">
                    {{ item.name }}
                    <el-input disabled v-model="item.point" placeholder="请输入..." style="width: 80px"></el-input>
                    积分
                  </li>
                  <br />
                </ul>
              </template>
            </div>
          </el-form-item>
          <el-form-item label="规则说明:" v-if="theSta == 1">
            <el-input disabled v-model="amendForm.ruleDescription" placeholder="请输入内容" type="textarea" :rows="5"></el-input>
          </el-form-item>
          <el-form-item label="规则说明:" v-if="theSta == 0">
            <el-input v-model="amendForm.ruleDescription" placeholder="请输入内容" type="textarea" :rows="5"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="theSta == 0">
        <el-button @click="dialogFormVis = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisB" v-loading="dialogFormBtnLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="身份验证"
      width="600px"
      :show-close="false"
      custom-class="system-dialog"
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="form-box">
        <div class="form-item">
          <div class="item-label">手机号：</div>
          <div class="item-value">
            <el-input disabled placeholder="请输入..." v-model="phone" style="width: 280px"></el-input>
          </div>
        </div>
        <div class="form-item">
          <div class="item-label">验证码：</div>
          <div class="item-value">
            <el-input placeholder="请输入" v-model="code" style="width: 170px; margin-right: 12px"></el-input>
            <el-button type="primary" :disabled="codeDisabled" @click="getCodeInit">{{ codeMsg }}</el-button>
          </div>
        </div>
        <div class="form-item" style="margin-bottom: 8px">
          <div class="form-item" style="margin-bottom: 8px">
            <div class="item-label"></div>
            <div class="item-value">
              <div class="tip-box" style="background: #fff"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="save-btn">
        <button class="keepBtn" @click="savePhone()">
          确定
        </button>
        <button class="backBtn" @click="visible = false">取消</button>
      </div>
    </el-dialog>

    <!-- 删除活动弹框 -->
    <el-dialog title="提示" :visible.sync="outerVisible" width="400px" :before-close="closehandleDelete"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否删除活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 数据统计 -->
    <statistics v-if="createStep == 3 && !isNew" @returnStep="returnStep" @triggerVersion="triggerVersion" :rowData="rowData" :ids1="ids1"></statistics>
    <!-- 数据统计-新版 -->
    <statistics-new
      style="background-color: #fff"
      v-if="createStep == 3 && isNew"
      @returnStep="returnStep"
      @triggerVersion="triggerVersion"
      :rowData="rowData"
      :ids1="ids1"
    ></statistics-new>
    <!-- 积分活动 -->
    <create-coupons
      ref="createStep13"
      :isShow="createStep == 13"
      v-if="createStep == 13"
      :stepNum="stepNum"
      :tabActive="activityData.id"
      :activityData="activityData"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @return="returnStep1"
      :style="{'margin-top': top?'-70px':''}"
    ></create-coupons>
    <create-coupons2
      ref="createStep14"
      :isShow="createStep == 14"
      v-if="createStep == 14"
      :stepNum="stepNum"
      :tabActive="activityData.id"
      :activityData="activityData"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @returnback="returnStep1"
      :style="{'margin-top': top?'-70px':''}"
    ></create-coupons2>
    <!-- 兑换红包 -->
    <create-exchange-cash-red
      ref="createStep38"
      :isShow="createStep == 38"
      v-if="createStep == 38"
      :stepNum="stepNum"
      :tabActive="activityData.id"
      :activityData="activityData"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @returnback="returnStep1"
    ></create-exchange-cash-red>
     <!-- 积分兑换礼品卡/爱奇艺/百度网盘/PLUS会员 -->
     <create-exchange-common
      ref="createStep58"
      :isShow="[58,59,60,61].includes(createStep)"
      v-if="[58,59,60,61].includes(createStep)"
      :stepNum="stepNum"
      :activityData="activityData"
      :tabActive="activityData.id"
      :valueRow="valueRow"
      :isDraftEdit="isDraftEdit"
      @returnback="returnStep1"
    ></create-exchange-common>
    <!-- 生成人群 -->
    <crowdDialog v-if="isShowCrowdDialog" 
      :isShowCrowdDialog="isShowCrowdDialog" 
      :searchForm="{...formList2,dataFrom:1}" 
      :activityType="-1"
      :source="11"
      :hasSource="false"
      :defaultValue="true"
      defaultValueText="兑换记录创建"
      @close="crowdClose" 
    />
    <!-- 批量标记发货 -->
    <batch-upload
      v-if="batchLockVisible"
      :visible="batchLockVisible"
      action="/jd-hd-web/PointActivityAnalyticController/markingSendStatusBatch/fileUpload"
      @close="batchLockClose"
    ></batch-upload>
    <!-- 录入快递单号 -->
    <el-dialog
      title="录入快递单号"
      width="480px"
      v-if="sendOutGoodsShow"
      :visible.sync="sendOutGoodsShow"
      @close="blankEnterCoutierNum"
      class="enter_coutier_num_dialog"
    >
      <el-form :model="sendOutGoodsForm" label-width="120px">
        <el-form-item label="快递单号：">
          <el-input
            placeholder="请输入"
            v-model="enterCoutierNum"
            style="width: 250px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blankEnterCoutierNum">取消</el-button>
        <el-button type="primary" @click="goodsEnterCoutierSubmit">确定</el-button>
    </span>
    </el-dialog>
    <integral-mall-decoration v-if="createStep=='decoration'&&isShowIntegral" @returnStep="returnStep"></integral-mall-decoration>
     <!-- 增加奖品库存弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      :isExchangeAct="true"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 白名单弹窗 -->
    <exchange-whiteList
      v-model="isShowWhite"
      v-if="isShowWhite"
      :whiteRow="whiteRow"
    />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "../../components/inputForm";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
import qrcodeVue from "qrcode-vue";
import batchUpload from './components/batchUpload.vue'
import integralMallDecoration from "./components/integralMallDecoration.vue"
import {
  exchangeActivityList,
  deleteActivityList,
  updateActivityList,
  inquireActivity,
  changeActivity,
  getExchangeActivityRecord,
  updateActivity
} from "@/api/paradiseAndTaskCommonController.js";
import statistics from "./activity_data_statistics";
import statisticsNew from "./activity_data_statistics_new.vue";
import { querydetail,pointsExchange } from "@/api/integralCenter/couponWriteController.js";
import { getmoble, getSellerCheckCode, exportBatch } from "@/api/paradiseAndTaskCommonController.js";
import createCoupons from "./create_coupons.vue";
import createCoupons2 from "./create_coupons2.vue";
import createExchangeCashRed from "./create_exchangeCashRed.vue";
import {
  DeliveryStatus,
  markingSendStatusForPointActivity,
  pointsExchangeQuash
} from "@/api/integralCenter/PointActivityAnalyticController";
import {allAccount,getGiftCardPage} from "@/api/integralCenter/prizeCenter.js";
import crowdDialog from "@/components/crowd-Dialog.vue"
import createExchangeCommon from "./create_exchange_common.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import information from '@/views/integralCenter/components/information.vue';
import exchangeWhiteList from '@/views/integralCenter/components/exchangeWhiteList.vue';
export default {
  props: {
    inputShow: {
      default: true,
    },
    inputShow1: {
      default: false,
    },
    activityType: {
      default: "",
    },
    statisType: {
      default: 1,
    },
    top: {
      default: false
    }
  },
  components: {
    inputForm,
    qrcodeVue,
    statistics,
    statisticsNew,
    createCoupons,
    createCoupons2,
    createExchangeCashRed,
    crowdDialog,
    batchUpload,
    integralMallDecoration,
    createExchangeCommon,
    addPrizeNum,
    information,
    exchangeWhiteList
  },
  data() {
    return {
      isShowWhite: false,
      whiteRow: {},
      isDisabled: true,
      isShowIntegral: false,
      tabSwitchList: ["全部", "已上架", "待上架", "已下架", "草稿箱"],
      currIndex: 0,
      codeMsg: "获取验证码",
      code: "",
      phone: "",
      successMsg: "",
      // timer: "",
      countdown: 60,
      codeDisabled: false,
      ExprotData: "",
      // 验证码
      opentime: true,
      visible: false,
      timer: null, //验证码定时
      saveDisable: false,
      //
      rowData: {},
      ids1: "",
      createStep: 1,
      qrcodeVue: {
        size: 260,
        bgColor: "#fff",
        fgColor: "#000",
        value: "https://www.baidu.com/", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      pageName: "会员商城-活动列表",
      memberLevelList: [
        { value: "非会员", label: 0, point: "" },
        { value: "一星会员", label: 1, point: "" },
        { value: "二星会员", label: 2, point: "" },
        { value: "三星会员", label: 3, point: "" },
        { value: "四星会员", label: 4, point: "" },
        { value: "五星会员", label: 5, point: "" },
      ],
      talbeLoading: false,
      outerVisible: false,
      timeDay: 0, //活动持续天数
      theSta: 0,
      dialogFormVis: false,
      dialogFormBtnLoading: false,
      amendForm: {},
      couponTxt: {},
      // 表单配置项
      inputData: [
        {
          name: "礼品名称",
          val: "activityName",
          placeholder: "请填入礼品名称",
        },
        {
          name: "礼品类型",
          val: "activityType",
          selectArr: [
            { label: "全部", id: "", defaultValue: "" },
            { label: "兑换优惠券", id: 10 },
            { label: "兑换实物", id: 9 },
            { label: "兑换京豆", id: 29 },
            { label: "兑换E卡", id: 30 },
            { label: "兑换红包", id: 38 },
            { label: "积分加钱购", id: 55 },
            { label: "兑换爱奇艺会员", id: 58 },
            { label: "兑换PLUS会员", id: 59 },
            { label: "兑换礼品卡", id: 60 },
            { label: "兑换百度网盘", id: 61 },
          ],
        },
        {
          name: "上架状态",
          val: "status",
          selectArr: [
            { label: "全部", id: "", defaultValue: "" },
            { label: "待上架", id: 1 },
            { label: "已上架", id: 2 },
            { label: "已下架", id: 3 },
          ],
        }, 
        {
          name: "是否在积分商城显示",
          val: "isDisplay",
          selectArr: [
            { label: "全部", id: "", defaultValue: "" },
            { label: "是", id: 1 },
            { label: "否", id: 0 },
          ],
        },
      ],
      inputData1: [
        {
          name: "礼品名称：",
          val: "activityName",
          placeholder: "请填入活动名称",
        },
        {
          name: "上架状态",
          val: "status",
          selectArr: [
            { label: "全部", id: null },
            { label: "待上架", id: 1 },
            { label: "已上架", id: 2 },
            { label: "已下架", id: 3 },
          ],
        },
      ],
      inputData2:[
        {
          name: "用户昵称",
          val: "memberNick",
          placeholder: "请填入用户昵称",
        },
        {
          name: "发货状态",
          val: "deliveryStatus",
          selectArr: [
            { label: "全部", id: "", defaultValue: "" },
            { label: "待发货", id: 1 },
            { label: "已发货", id: 2 },
            { label: "无需发货", id: 3 },
          ],
        },
        {
          name: "兑换时间：",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
        {
          name: "兑换状态：",
          val: "exchangeStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: "", defaultValue: "" },
            { label: "兑换成功", id: 1 },
            { label: "兑换失败", id: 2 },
            { label: "领取成功", id: 3 },
            { label: "已撤回", id: 4 },
          ],
        },
        {
          name: "礼品名称：",
          val: "prizeName",
          placeholder: "请填入礼品名称",
        },
        {
          name: "礼品类型",
          val: "activityType",
          selectArr: [
            { label: "全部", id: "", defaultValue: "" },
            { label: "兑换实物", id: 9 },
            { label: "兑换优惠券", id: 10 },
            { label: "兑换京豆", id: 29 },
    
            { label: "兑换E卡", id: 30},
            { label: "兑换红包", id: 38 },
            { label: "积分加钱购", id: 55 },
            { label: "兑换爱奇艺会员", id: 58 },
            { label: "兑换PLUS会员", id: 59 },
            { label: "兑换礼品卡", id: 60 },
            { label: "兑换百度网盘", id: 61 },
          ],
        },
      ],
      // 表格数据
      tableData: [],
      tableData2: [],
      // 所需积分内容展开
      tableOpenAll: false,
      // 当前页
      currentPage: 1,
      pageshow: true,
      totalNum: 0,
      formList: {
        current: 1,
        size: 10,
      },
      status: 0,
      ids: null,
      qrcode: null,
      venderType: 0,
      activityData: {},
      valueRow:null,
      activeName:'first',//当前栏目
      // 发货弹窗
      sendOutGoodsForm: {
        id: "",
        billCode: "",
        isUpdatePrizeStatus: true,
        isShowCrowdDialog: false,
      },
      formList2: {
        size: 10,
        current: 1,
      },
      rowData:{},
      source: "",
      isShowCrowdDialog: false,
      enterCoutierNum:"",
      enterCoutierRowData:{},
      sendOutGoodsShow:false,
      batchLockVisible:false,
      isNew:false,
      isDraftEdit:false,
      stepNum:0,
      aqyList: [
        {
          label: "月卡",
          value: '8',
          quantityBalance: 0
        },
        {
          label: "季卡",
          value: '12',
          quantityBalance: 0
        },
        {
          label: "半年卡",
          value: '13',
          quantityBalance: 0
        },
        {
          label: "年卡",
          value: '14',
          quantityBalance: 0
        },
      ],
      jdPlusList: [
        {
          label: "年卡",
          value: '7',
          quantityBalance: 0
        },
      ],
      prizeMemberList: [],
      giftCardList: [],
      laoding: false,
      activityTypeListAll:[58,59,60,61],
      activityTypeList:[58,59],
      activityTypeList1:[60,61],
      quantityBalance: 0,
      toAddItem: {},
      isShowAddNum: false,
    };
  },
  computed: {
    labelText() {
      const textType = {
        58: "爱奇艺会员面值:",
        59: "plus会员面值:",
        60: "选择礼品卡:",
        61: "选择百度网盘:",
      };
      return textType[this.amendForm.activityType] || "";
    },
  },
  filters: {
    activityString(key) {
      let obj = {
        9: "兑换实物",
        10: "兑换优惠券",
        29: "兑换京豆",
        30: "兑换E卡",
        38: "兑换红包",
        55: "积分加钱购",
        58: "兑换爱奇艺会员",
        59: "兑换PLUS会员",
        60: "兑换礼品卡",
        61: "兑换百度网盘",
      };
      return obj[key];
    },
  },
  created() {
    this.prefixQue();
    getmoble().then((res)=>{
      this.venderType = res.data.venderType
    })
  },
  mounted() {
    this.getChangeList();
  },
  methods: {
    handleWhiteList(row) {
      this.whiteRow = {...row}
      this.isShowWhite = true
    },
     confirmAdd(num) {
      this.isShowAddNum = false;
      this.getChangeList();
    },
    //增加奖品库存
    addInventory(row) {
      this.toAddItem = {
        num: row.num,
        title: row.activityName,
        activityId: row.id
      };
      this.isShowAddNum = true;
    },
    //编辑
    modify(row, type = "edit") {
      // 只适用编辑
     if (row.activityType == 9){//兑换实物    
        this.createStep = 13;
        let coverSrc = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/";
        this.activityData = {
          id: 9,
          name: "积分兑换实物",
          telImg: "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/cover/sw.png",
          telCode: coverSrc + "sw.png",
          singleCopy: false,
          isEdit: type=='edit',
          activityType: row.activityType,
          status: row.status,
        };
        this.valueRow = {
          id:row.id
        }
        this.stepNum = 1; // 编辑时直接跳转到规则设置页面
        this.$emit("handleshow", false);
      } 
    },
    handlePrizeChange(val,type) {
      let newList = []
      if(type==1) {
        newList = this.prizeMemberList
      } else {
        newList = this.giftCardList
      }
      if (newList.length > 0) {
        let obj = newList.find((item) => item.value == val);
        if (obj) {
          this.quantityBalance = obj.quantityBalance;
          if(type==2) {
            this.giftCardEndTime = obj.endTime;
          }
        }
      }
    },
    //获取爱奇艺会员列表
    getPrizeMemberList(activityType) {
      const types = {
        58: 4,
        59: 3,
      };
      const activiTypes = {
        58: this.aqyList,
        59: this.jdPlusList,
      };
      return allAccount({ type: types[activityType] }).then((res) => {
        if (res.data && res.data.length > 0) {
          this.prizeMemberList = res.data.map((item, index) => {
            let obj = {
              label: "",
              value: "",
              quantityBalance: 0
            };
            obj.label = `${item.itemName}（剩余${item.quantityBalance}${item.unit}）`;
            obj.value = item.itemId;
            obj.quantityBalance = item.quantityBalance;
            return obj;
          });
        } else {
          this.prizeMemberList = activiTypes[activityType].map(
            (item, index) => {
              item.label = `${item.label}（剩余0张）`;
              return item;
            }
          );
        }
        this.amendForm.itemId = this.prizeMemberList[0].value;
        this.quantityBalance = this.prizeMemberList[0].quantityBalance;
      });
    },
    async getList(activityType) {
      try {
        const types = {
          60: "0,1",
          61: "2",
        };
        const params = {
          current: 1,
          size: 100000,
          activateTypeStr: types[activityType],
        };
        const res = await getGiftCardPage(params);
        if (res.code == 1) {
          if (res.data.records && res.data.records.length > 0) {
            this.giftCardList = res.data.records.map((item) => {
              return {
                label: item.planName,
                value: item.id,
                quantityBalance: item.quantityBalance,
              };
            });
            this.amendForm.assetsId = this.giftCardList[0].value;
            this.quantityBalance = this.giftCardList[0].quantityBalance;
          }
        }
      } catch (error) {}
    },
    // 撤回发货
    revocationIntegralGoods(row){
      this.$confirm(`您的订单状态为${row.deliveryStatus === 1 ? '待发货' : '已发货'}，是否进行撤回！`,"提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(res=>{
        console.log(row);
        pointsExchangeQuash({
          id: row.id,
        }).then(res=>{
          this.$message.success("撤回成功")
          this.getExchangeActivityRecord()
        })
      })
    },
    handleToDecoration() {
      this.isShowIntegral = true
      this.createStep = "decoration"
    },
    // 是否在商城显示/优先级
    async handleChangeDisplayOrSort(val,row,flag) {
      let params = {
        id:row.id
      }
      if(flag=="isDisplay") {
        params.isDisplay = val
        params.sort = row.sort || 1
      } else {
      if(!val) {
       return this.$message.warning("优先级不能为空")
      }
        params.sort = val
        params.isDisplay = row.isDisplay
      }
      try {
        const res = await updateActivity(params)
        if(res.code==1) {
          this.$message.success(res.message)
          this.getChangeList();
        }
      } catch (error) {
        this.$message.error(res.message)
      }
    },
    // 新版本切换
    triggerVersion(val){
      this.isNew = val
    },
    //切换
    handleClick(e){
      console.log("切换tab",e.index)
      if(e.index == 1){
        this.getExchangeActivityRecord();
      }else{
        this.getChangeList();
      }
    },

    handleTab(i) {
      this.currIndex = i;
      if (i == 0) this.formList.status = "";
      if (i == 1) this.formList.status = 2;
      if (i == 2) this.formList.status = 1;
      if (i == 3) this.formList.status = 3;
      if (i == 4) this.formList.status = 5;
      // 草稿箱调整上架状态
      if(i == 4){
        this.inputData[2].selectArr = [{ label: "草稿箱", id: 5 }]
      }else{
        this.inputData[2].selectArr = [
          { label: "全部", id: null, defaultValue: "" },
          { label: "待上架", id: 1 },
          { label: "已上架", id: 2 },
        ]
      }
      this.inputData[2].selectArr[0].defaultValue = this.formList.status;
      this.$refs["inputForm"].initVal();
      this.getChangeList();
    },
    /** 获取验证码 */
    getCodeInit() {
      if (!this.timer) {
        getSellerCheckCode().then((res) => {
          if (res.code == 1) {
            this.codeDisabled = true;
            this.timer = setInterval(() => {
              if (this.countdown > 0 && this.countdown <= 60) {
                this.countdown--;
                if (this.countdown !== 0) {
                  this.codeMsg = "重新发送(" + this.countdown + ")";
                } else {
                  clearInterval(this.timer);
                  this.codeMsg = "获取验证码";
                  this.countdown = 60;
                  this.timer = null;
                  this.codeDisabled = false;
                }
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    savePhone() {
      if (!this.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      // let params = {
      //   code: this.code,
      //   endTime: this.formList.endTime,
      //   startTime: this.formList.startTime,
      //   activityId: this.formList.activityId,
      // };
      let params = {
        ...this.formList2,
        code: this.code
      }
      let typeObj = {
        1: 10,
        2: 29,
        3: 9,
        5: 30,
        8: 38
      }
      if(params.activityType && params.activityType != ''){
        params.activityType = typeObj[params.activityType];
      }
      exportBatch(params).then((res) => {
        if (res.code == 1) {
          var blob = new Blob([res.blob]);
          var link = document.createElement("a"); //a标签下载
          link.href = window.URL.createObjectURL(blob);
          link.download = "互动商城.xls";
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.visible = false;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    async getphone() {
      this.code = "";
      const { data: res } = await getmoble();
      this.visible = true;
      this.phone = res.mobile;
      this.countdown = 60;
      this.codeDisabled = false;
      this.codeMsg = "获取验证码"; // 按钮上的文字
      this.venderType = res.venderType
      clearInterval(this.timer);
      this.timer = null;
      this.venderType = res.venderType
      // console.log(this.formDataList, 9999);
    },
    returnStep() {
      this.createStep = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.getChangeList();
    },
    returnStep1(){
      this.createStep = 1;
      this.formList.current = 1;
      this.formList.size = 10;
      this.getChangeList();
      this.$emit("handleshow", true);
    },
    handleSrcImg(id) {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode${id} img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "huodongyulan";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    searchClick(val) {
      this.formList.activityName = val.activityName;
      this.formList.activityType = val.activityType;
      this.formList.status = val.status;
      this.currentPage = 1;
      this.getChangeList();
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    //获取活动地址
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //关闭弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.getChangeList();
    },
    //获取列表数据
    getChangeList() {
      this.talbeLoading = true;
      if (this.inputShow1) this.formList.activityType = this.activityType;
      exchangeActivityList(this.formList).then((res) => {
        this.tableData.forEach((item, index) => {
          var ref = "qrcode" + item.id;
          // console.log( this.$refs[ref])
          this.$nextTick(() => {
            if(this.$refs[ref]){
              this.$refs[ref].innerHTML = "";
            }
          });
        });
        this.talbeLoading = false;
        this.tableData = res.data.records.map((item) => {
          return {
            ...item,
            days: this.DayHours(item.startTime, item.endTime, item.status),
          };
        });
        this.totalNum = Number(res.data.total);
        this.prefixQue();
        // console.log(res.data, 222222);
        let mesUrl = "";
        this.tableData.forEach((item) => {
          // if (item.activityType == 9) {
          //   mesUrl = "integralStore_exchange";
          // } else if (item.activityType == 10) {
          //   mesUrl = "integralStore_discount";
          // }
          // item.idUrl = this.activityUrl + "/" + mesUrl + "?id=" + item.id + "&venderId=" + this.venderId;

          let xcxUrl = this.$commonUrl(); // 正式
          let options = {
            activityId: item.id,
            venderId: this.venderId,
            activityType: item.activityType || item.type,
            id: item.id,
          };
          let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%2C%22activityType%22%3A${options.activityType}%2C%22id%22%3A${options.id}%7D`;
          let pcParams = encodeURIComponent(
            Object.keys(options)
              .map((item) => `${item}=${options[item]}`)
              .join("&")
          );
          if (item.activityType == 9) {
            item.idUrl = xcxUrl + "pages/integralStore/exchange/exchange.html%3F" + pcParams;
          }
          if (item.activityType == 10) {
            item.idUrl = xcxUrl + "pages/integralStore/discount/discount.html%3F" + pcParams;
          }
          //  京豆、e卡
          if (item.activityType == 29 || item.activityType == 30) {
            item.idUrl = xcxUrl + "pages/integralStore/conversionDou/conversionDou.html%3F" + pcParams;
          }
          if(item.activityType == 38){
            item.idUrl = xcxUrl + "pages/integralStore/exchangeHb/exchangeHb.html%3F" + pcParams;
          }
          
          if(item.activityType == 55){
            item.idUrl = xcxUrl + "pages_2/addMoneyToBuy/addMoneyToBuy.html%3F" + pcParams;
          }

          if(item.activityType == 58 || item.activityType == 59 || item.activityType == 60 || item.activityType==61){
            item.idUrl = xcxUrl + "pages/integralStore/giftCard/giftCard.html%3F" + pcParams;
          }

          // this.$nextTick(() => {
          //   let queryId = "qrcode" + item.id;
          //   this.qrcodeAll(item.idUrl, queryId);
          // });
        });
        // console.log(this.tableData, 222222);
      });
    },
    //活动时间驱动
    activityTimeChange(val) {
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.amendForm.startTime.substring(0, 10);
      daysEnd = this.amendForm.endTime.substring(0, 10);
      if (this.amendForm.endTime != "" && this.amendForm.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.amendForm.endTime).getTime() - new Date(this.amendForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
        return;
      }
    },
    // 表单查询
    searchForm(val) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.currentPage = 1;
      this.formList.activityName = val.activityName;
      this.formList.activityType = val.activityType;
      this.formList.status = val.status;
      this.formList.isDisplay = val.isDisplay;
      this.getChangeList();

      this.pageshow = false; //让分页隐藏
      this.$nextTick(() => {
        //重新渲染分页
        this.pageshow = true;
      });
    },
     // 表单查询
     searchForm2(val) {
      console.log("表单查询2",val)
      this.formList2.current = 1;
      this.formList2.size = 10;
      this.currentPage = 1;
      this.formList2.memberNick = val.memberNick;
      this.formList2.deliveryStatus = val.deliveryStatus;
      this.formList2.startTime = val.startTime;
      this.formList2.endTime = val.endTime;
      this.formList2.exchangeStatus = val.exchangeStatus;
      this.formList2.prizeName = val.prizeName;
      // this.formList2.prizeType = val.prizeType;
      // this.formList2.activityName = val.prizeName;
      this.formList2.activityType  = val.activityType;

      this.getExchangeActivityRecord();

      this.pageshow = false; //让分页隐藏
      this.$nextTick(() => {
        //重新渲染分页
        this.pageshow = true;
      });
    },
    getExchangeActivityRecord(){
      this.talbeLoading = true;
      let params = {
        ...this.formList2,dataFrom:1
      }
      if (this.inputShow1){ params.activityType = this.activityType;Vue.filter(id, [definition])}
      // else {
      //   let typeObj = {
      //   1: 10,
      //   2: 29,
      //   3: 9,
      //   5: 30,
      //   8: 38
      //   }
      //   if(params.activityType && params.activityType != '')
      //   params.activityType = typeObj[params.activityType];
      // }
      getExchangeActivityRecord(params).then((res) => {
        this.talbeLoading = false;
        this.tableData2 = res.data.records
        this.totalNum = Number(res.data.total);
      });
    },
    // 点击解密
    handleDecrypt1(name, item, index) {
      let params = "encrypt" + name[0].toUpperCase() + name.substring(1, name.length);

      this.$decrypt.decrypt({ decryptContent: item[`${params}`] }).then((res) => {
        this.tableData2[index][`${name}`] = res.message;
      });
    },
    //标记发货
    changeShip(row) {
      // let id = row.id;
      console.log(row);
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        DeliveryStatus(row.id,1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              this.getExchangeActivityRecord();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    // 取消发货
    cancelShip(row){
      this.$confirm("是否取消发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        DeliveryStatus(row.id,1)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success('取消发货成功');
              this.getExchangeActivityRecord();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((res) => {});
      });
    },
    //修改
   async changeList(row) {
      this.theSta = 0;
      this.dialogFormVis = true;
      let id = row.id;
      if(this.activityTypeList.includes(row.activityType)){
        await this.getPrizeMemberList(row.activityType)
      } else if(this.activityTypeList1.includes(row.activityType)) {
        await this.getList(row.activityType)
      }
      this.loading = true;
      inquireActivity(id)
        .then((res) => {
          this.loading = false;
          res.data.ruleDTO = res.data.ruleDTO || {
            condFollow: 0,
            activityTargetType: '2', // 固定值
            allowLevel: "-1",
            plusObject: 0,
            crowdIds: "",
            firstOpenCardTimeType: 0,
            openCardBeforeDay: "",
            orderCompleteLimitCount: "",
            orderCompleteMaxCount: "",
            orderCompleteLimitPayment: "",
            orderCompleteMaxPayment: "",
            lastOrderCompleteTimeType: 0,
            lastOrderCompleteStartDay: "",
            lastOrderCompleteEndDay: "",
            lastOrderCompleteStartTime: "",
            lastOrderCompleteEndTime: "",
            isCheckOpenCardTime: "",
            openCardStartTime: "",
            openCardEndTime: "",
          };
          this.amendForm = res.data;
          this.memberLevelList = [];
          this.amendForm.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow == true) {
              this.memberLevelList.push(item);
            }
          });
          // });
          if (res.data.exchangeTimes < 0) {
            this.amendForm.exchangeTimes = null;
          }
          if (res.data.activityType == 30||this.activityTypeListAll.includes(res.data.activityType)) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayTimes == -1 ? "" : res.data.exchangeDayTimes;
            this.amendForm.exchangeNum = res.data.exchangeTimes == -1 ? "" : res.data.exchangeTimes;
            // this.amendForm.itemId = res.data.itemId * 1;
          }
          if (res.data.activityType == 29) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayNum == -1 ? "" : res.data.exchangeDayNum;
            this.amendForm.exchangeNum = res.data.exchangeNum == -1 ? "" : res.data.exchangeNum;
            this.amendForm.limitVal = res.data.ruleType == 1 ? res.data.exchangeDayTimes : res.data.exchangeTimes;
          }

          this.activityTimeChange();
          // console.log(res.data, this.memberLevelList, 111);
          this.couponTxt = {};
          if (this.amendForm.activityType == 10 && this.venderType == 0) {
            querydetail(Number(this.amendForm.couponId))
              .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {});
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    //修改确定
    dialogFormVisB() {
      let obj = {
        activityName: this.amendForm.activityName,
        activityType: Number(this.amendForm.activityType),
        id: Number(this.amendForm.id),
        ruleDescription: this.amendForm.ruleDescription,
      };
      // console.log(row,111);
      // console.log(obj, 222);
      let editApi = changeActivity;
      if(this.amendForm.status == 2) {
        editApi = updateActivity;
      }
      this.dialogFormBtnLoading = true;
      editApi(obj)
        .then((res) => {
          this.dialogFormVis = false;
          if (res && res.id || res.code == 1) {
            this.dialogFormBtnLoading = false;
            this.getChangeList();
            this.$message.success("修改成功");
          } else {
            this.$message.error("修改失败");
          }
        })
        .catch((res) => {
          console.error(res);
          this.dialogFormBtnLoading = false;
        });
    },
    //查看
   async seeList(row,type,copy = false,isDraft = false) {
      this.theSta = 1;
      // 复制草稿箱
      if(copy || isDraft){
        let coverSrc = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/";
        this.isDraftEdit = isDraft
        let activityData = {}
        let createStep;
        switch(type){
          case 9:
            createStep = 13;
            activityData = {
              id: 9,
              name: "积分兑换实物",
              telImg: require("@/assets/thdImg/cover/sw.png"),
              telCode: coverSrc + "sw.png",
              singleCopy:copy
            };
          break;
          case 10:
            createStep = 13;
            activityData = {
              id: 10,
              name: "积分兑换优惠券",
              telImg: require("@/assets/thdImg/cover/yhq.png"),
              telCode: coverSrc + "yhq.png",
              singleCopy:copy
            };
          break;
          case 29:
          createStep = 14;
          activityData = {
            id: 29,
            name: "积分兑换京豆",
            telImg: require("@/assets/thdImg/cover/jd.png"),
            telCode: coverSrc + "sw.png",
            singleCopy:copy
          };
          break;
          case 30:
            createStep = 14;
            activityData = {
              id: 30,
              name: "积分兑换E卡",
              telImg: require("@/assets/thdImg/cover/Ek.png"),
              telCode: coverSrc + "yhq.png",
              singleCopy:copy
            };
          break;
          case 38:
          createStep = 38;
          activityData = {
            id: 38,
            name: "积分兑换红包",
            telImg: require("@/assets/thdImg/cover/dhhb.png"),
            telCode: coverSrc + "dhhb.png",
            singleCopy:copy
          };
          break;
          case 58:
            createStep = 58;
            activityData = {
              id: 58,
              name: "积分兑换爱奇艺会员",
              singleCopy:copy
            };
          break;
          case 59:
            createStep = 59;
            activityData = {
              id: 59,
              name: "积分兑换京东PLUS会员",
              singleCopy:copy
            };
          break;
          case 60:
            createStep = 60;
            activityData = {
              id: 60,
              name: "积分兑换礼品卡",
              singleCopy:copy
            };
          break;
          case 61:
            createStep = 61;
            activityData = {
              id: 61,
              name: "积分兑换百度网盘",
              singleCopy:copy
            };
          break;
        }
        this.createStep = createStep
        this.activityData = activityData
        this.stepNum = isDraft?1:0
        this.valueRow = {
          id:row.id
        }
      }else{
        if(this.activityTypeList.includes(row.activityType)){
          await this.getPrizeMemberList(row.activityType)
        } else if(this.activityTypeList1.includes(row.activityType)) {
          await this.getList(row.activityType)
        }
        this.loading = true;
        inquireActivity(row.id)
        .then((res) => {
          this.loading = false
          console.log(res.data);
          res.data.ruleDTO.goShopSetting = res.data.ruleDTO.goShopSetting || 0;
          this.amendForm = res.data;
          this.memberLevelList = [];
          this.amendForm.memberLevelPointsDTOList.forEach((item) => {
            if (item.allow == true) {
              this.memberLevelList.push(item);
            }
          });
          // });
          if (res.data.exchangeTimes < 0) {
            this.amendForm.exchangeTimes = null;
          }
          if (res.data.activityType == 30||this.activityTypeListAll.includes(res.data.activityType)) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayTimes == -1 ? "" : res.data.exchangeDayTimes;
            this.amendForm.exchangeNum = res.data.exchangeTimes == -1 ? "" : res.data.exchangeTimes;
            // this.amendForm.itemId = res.data.itemId * 1;
          }
          if (res.data.activityType == 29) {
            this.amendForm.exchangeDayNum = res.data.exchangeDayNum == -1 ? "" : res.data.exchangeDayNum;
            this.amendForm.exchangeNum = res.data.exchangeNum == -1 ? "" : res.data.exchangeNum;
            this.amendForm.limitVal = res.data.ruleType == 1 ? res.data.exchangeDayTimes : res.data.exchangeTimes;
          }

          if(res.data.activityType == 38){
            this.amendForm.exchangeDayTimes=res.data.exchangeDayTimes
            this.amendForm.exchangeTimes=res.data.exchangeTimes
            this.amendForm.exchangeNum=res.data.exchangeNum
            this.amendForm.exchangeDayNum=res.data.exchangeDayNum
            this.amendForm.redPacketExpiration=res.data.redPacketExpiration
            this.amendForm.effectiveDays=Number(res.data.effectiveDays)
            if(res.data.redPacketExpiration == 1){
              this.amendForm.effectiveStartTime=res.data.startTime
              this.amendForm.effectiveEndTime=res.data.effectiveEndTime
            }
          }
          this.activityTimeChange();
          // console.log(res.data, this.memberLevelList, 111);
          this.couponTxt = {};
            console.log(this.amendForm.activityType,'112233');
          if (this.amendForm.activityType == 10) {
            console.log(this.amendForm);
            
            if (this.amendForm.externalCouponId) {
              pointsExchange(Number(this.amendForm.externalCouponId))
                .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {});
            }else{
              querydetail(Number(this.amendForm.couponId))
              .then((res) => {
                this.couponTxt = res.data;
                this.couponTxt.beginTime = this.couponTxt.beginTime.substring(0, 10);
                this.couponTxt.endTime = this.couponTxt.endTime.substring(0, 10);
              })
              .catch((res) => {});
            }
          }
          this.dialogFormVis = true;
        })
      }
    },
    // 数据统计
    statisData(row) {
      if (this.statisType == 1) {
        this.rowData = row;
        this.ids1 = row.id;
        this.createStep = 3;
        // 判断活动时间是否为新版
        this.isNew = this.isCurrentTimeAfter(row.updateTime)
      } else {
        this.$emit("statisDataCreate", row);
      }
    },

    amendTheList() {},
    //删除
    deleteById(row) {
      this.ids = Number(row.id);
      this.outerVisible = true;
    },
    handleDeleteTable() {
      let id = this.ids;
      deleteActivityList(id)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.getChangeList();
          } else {
            this.$message.error(res.message);
          }
          this.outerVisible = false;
        })
        .catch((res) => {});
    },
    //上下架
    updateList(row) {
      if (row.status == 1) {
        this.status = 2;
      } else if (row.status == 2) {
        this.status = 3;
      }
      let list = {
        id: Number(row.id),
        status: Number(this.status),
      };
      console.log(list);
      updateActivityList(list)
        .then((res) => {
          console.log(res);
          if (res && res.code == 1) {
            this.$message.success(res.message);
            this.getChangeList();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          // console.log(res, "res");
          // this.$message.error(res.message);
        });
    },
    DayHours(start, end, status) {
      // let startTime = new Date(start);
      // let endTime = new Date(end);
      let nowTime = this.formatDate(new Date());
      let res = "";
      // 未开始
      if (status == 1) {
        let arr = this.timediff(start, nowTime);
        res = arr[0] + "天" + arr[1] + "小时" + arr[2] + "分后开始";
      }
      // 进行中
      if (status == 2) {
        let arr = this.timediff(start, nowTime);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      // 已结束
      if (status == 3) {
        let arr = this.timediff(start, end);
        res = "活动持续了" + arr[0] + "天" + arr[1] + "小时" + arr[2] + "分";
      }
      return res;
    },
    timediff(begin_time, end_time) {
      //年月日时分秒转换为时间戳
      let beginTime = new Date(begin_time).getTime() / 1000;
      let endTime = new Date(end_time).getTime() / 1000;
      var starttime = "";
      var endtime = "";
      if (beginTime < endTime) {
        starttime = beginTime;
        endtime = endTime;
      } else {
        starttime = endTime;
        endtime = beginTime;
      }
      //计算天数
      var timediff = endtime - starttime;
      var days = parseInt(timediff / 86400);
      //计算小时数
      var remain = timediff % 86400;
      var hours = parseInt(remain / 3600);
      //计算分钟数
      var remain = remain % 3600;
      var mins = parseInt(remain / 60);
      // var res = days + "天" + hours + "小时" + mins + "分";
      return [days, hours, mins];
    },
    formatDate(date, fmt = "yyyy-MM-dd hh:mm:ss") {
      let currentDate = new Date(date);
      let o = {
        "M+": currentDate.getMonth() + 1, //月份
        "d+": currentDate.getDate(), //日
        "h+": currentDate.getHours(), //小时
        "m+": currentDate.getMinutes(), //分
        "s+": currentDate.getSeconds(), //秒
        "q+": Math.floor((currentDate.getMonth() + 3) / 3), //季度
        S: currentDate.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (currentDate.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      return fmt;
    },
    // 分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.getChangeList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.getChangeList();
    },

    // 分页事件
    handleSizeChange2(val) {
      this.formList2.size = val;
      this.getExchangeActivityRecord();
    },
    handleCurrentChange2(val) {
      this.formList2.current = val;
      this.getExchangeActivityRecord();
    },
    addCrowd(val){
      console.log(this.loginUserInfo)
      this.source = val
      this.isShowCrowdDialog = true
    },
    crowdClose(){
      this.isShowCrowdDialog = false
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
      this.sendOutGoodsShow = false;
    },
    // 发货信息确定
    goodsEnterCoutierSubmit() {
      let params = {
        recordId: this.enterCoutierRowData.id,
        billCode: this.enterCoutierNum,
        // 这里默认传true
        isUpdatePrizeStatus: true,
      }
      markingSendStatusForPointActivity(params).then((res) => {
        console.log("markingSendStatusLockRight", res);
        if(res.code == 1){
          // 置空录入快递单号输入框
          this.blankEnterCoutierNum();
          this.$message.success("录入快递单号成功");
          // 刷新列表
          this.getExchangeActivityRecord();
        }else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message.error("录入快递单号失败");
      })
    },
    // 录入快递单号
    shipment(row){
      this.enterCoutierRowData = row
      this.sendOutGoodsShow = true
    },
    // 批量标记发货
    batchMarkForShipment(){
      this.batchLockVisible = true
    },
    // 关闭批量标记发货
    batchLockClose(){
      this.batchLockVisible = false
    },
    // 编辑草稿箱
    editDraft(row){
      this.seeList(row,row.activityType,false,true)
    }
  },
};
</script>

<style scoped lang="scss">
.draft-btn{
  width: auto;
  padding: 0px!important;
}
.delivery {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
  &+&{
    margin-left: 8px;
  }
}
.backBtn {
  margin-left: 20px;
  width: 98px;
  height: 32px;
  color: #666666;
  border-radius: 3px;
  border: 1px solid #dddddd;
  background-color: #fff;
  &:hover {
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background: rgba(123, 97, 255, 0.1);
  }
  &:active {
    color: #7b61ff;
    border: 1px solid #7b61ff;
    background: rgba(123, 97, 255, 0.1);
  }
}
.keepBtn {
  width: 98px;
  height: 32px;
  border-radius: 3px;
  background-color: #7b61ff;
  color: #fff;
  &:hover {
    opacity: 0.9;
  }
}
/deep/.system-dialog {
  .el-dialog__body {
    padding: 16px 30px 30px 30px;
  }
  .form-box {
    padding-top: 16px;
    .form-item {
      font-size: 14px;
      color: #333;
      margin-bottom: 12px;
      .item-label {
        display: inline-block;
        width: 76px;
        text-align: right;
      }
      .item-value {
        display: inline-block;
      }
    }
  }
  .save-btn {
    text-align: center;
  }
}
.questionMark {
    //   height: 20px;
    margin-bottom: -3px;
    cursor: pointer;
}
.tabSwitch {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-left {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    // padding: 0 20px;
    margin-bottom: 24px;
    position: relative;
    height: 50px;
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #f6f6f6;
    .left-wz {
      height: 50px;
      line-height: 50px;
      position: relative;
      margin-right: 24px;
      cursor: pointer;
      transition: all 0.2s;
    }
  }
  .active {
    color: #7b61ff;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      background-color: #7b61ff;
      transition: all 0.2s;
      animation: opation 0.2s;
    }
    @keyframes opation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 100%;
      }
    }
  }
}
.topbox {
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
.gift_list {
  box-sizing: border-box;
  padding: 20px 28px 30px;
  margin: 24px;
  background: #fff;
  .activityName {
    display: flex;
    align-items: center;
    font-size: 14px;
    .code {
      margin-right: 4px;
      cursor: pointer;
    }
  }
  .pContent {
    // display: block;
    float: left;
    width: 250px;
    color: #999999;
  }
  .couponContent {
    height: 130px;
    width: 260px;
    border: 1px solid #dddddd;
    border-radius: 10px;
    position: relative;
    .txtNum {
      position: absolute;
      margin: 25px;
      width: 160px;
    }
    .txtSize {
      margin: 20px 0 0 140px;
    }
    .time {
      font-size: 12px;
      margin-left: 30px;
      color: #999999;
    }
    .btn {
      display: none;
      opacity: 0;
    }
  }
  .isLevelSet {
    // display: flex;
    .levelList {
      display: flex;
      flex-wrap: wrap;
      width: 450px;
      .item {
        text-align: right;
        margin-bottom: 16px;
        font-size: 14px;
        color: #333;
      }
    }
  }
  .limitBox {
    .desc {
      font-size: 13px;
      color: #999;
      i {
        color: #fe8f8a;
        opacity: 0.8;
      }
    }
  }
  .activityTime {
    display: flex;
    flex-direction: column;
  }
  .open,
  .stop {
    color: #7b61ff;
    cursor: pointer;
  }
  .tooltip {
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .hoveTitleShowMore {
    width: 90%;
  }
  .editList {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
    span {
      // flex: 1;
      cursor: pointer;
    }
    .edit,
    .count {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #7b61ff;
      }
    }
    .end,
    .delete {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #7b61ff;
      }
    }
  }
  .y1,
  .y2,
  .y3 {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .y1 {
    background-color: #cccccc;
  }
  .y2 {
    background-color: #7f85e9;
  }
  .y3 {
    background-color: #7b61ff;
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
  .buttonBox {
    .b1 {
      width: 98px;
      height: 32px;
      color: #666666;
      // position: absolute;
      border-radius: 3px;
      margin-top: 20px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background-color: #fff4f4;
      }
      &:active {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background-color: #fff4f4;
      }
    }
    .b2 {
      width: 98px;
      // position: absolute;
      // margin-right: 80px;
      height: 32px;
      margin: 20px 80px 10px 10px;
      border: 1px solid #7b61ff;
      color: #ffffff;
      border-radius: 3px;
      background-color: #7b61ff;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #7b61ff;
      }
      &:active {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background-color: #fff4f4;
      }
    }
  }
}
.btn-wrap{
  display: flex;
  align-items: center;
}
</style>
